import { PropsWithChildren } from 'react';

import { Redirect } from 'react-router-dom';
import { buildRouteUrl } from '../../utils/routing';
import { pageVar } from '../../state/appState';
import { routes } from '../../constants';
import { useReactiveVar } from '@apollo/client';

export const RequireCause = ({ children }: PropsWithChildren) => {
  const cause = useReactiveVar(pageVar)?.cause;

  if (!cause) {
    return <Redirect to={buildRouteUrl(routes.cause)} />;
  }

  return children;
};
